// extracted by mini-css-extract-plugin
export default {"container":"tY6RRlaO7aNE930Wsr0Z"};